var map = {
	"./ca/popovers": 58497,
	"./de/popovers": 35488,
	"./en/popovers": 97884,
	"./es/popovers": 10489,
	"./eu/popovers": 26603,
	"./fr/popovers": 55221,
	"./it/popovers": 67326,
	"./pt/popovers": 93845
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20445;